import { API_VERSION } from './api/constans';
import { authentication } from './components/authentication';
import { AUTHORIZATION_TOKEN, CORRELATION_ID } from './constants/storage';
import { apiVersionMismatch, badGateway, internalServerError, noNetworkConnection } from './constants/httpStatus';

const requestInterceptor = (request: Request) => {
  const token = localStorage.getItem(AUTHORIZATION_TOKEN);
  const correlationId = localStorage.getItem(CORRELATION_ID);
  const headers = new Headers(request?.headers);

  if (correlationId) {
    headers.set('X-Request-Correlation-Id-V2', correlationId);
  }

  if (token) {
    headers.set('Authorization', `Bearer ${token}`);
    headers.set('X-Frontend-API-version', API_VERSION);
  }
  return { ...request, headers };
};

const responseInterceptor = (request: Partial<Request> | undefined, response: Response) => {
  const correlationId = localStorage.getItem(CORRELATION_ID);

  if (response.status === apiVersionMismatch.status) {
    authentication.logout({ text: apiVersionMismatch.message, correlationId, severity: 'error' });
    throw new Error(apiVersionMismatch.message);
  }

  /**
   *  At first, we want to handle all 5xx GET errors by the component itself that's why we pass error next
   */
  if (request?.method === 'GET' && response.status >= 500) {
    return;
  }

  if (response.status === badGateway.status) {
    authentication.logout({ text: badGateway.message, correlationId, severity: 'error' });
    throw new Error(badGateway.message);
  }

  if (response.status === internalServerError.status) {
    authentication.logout({ text: response.statusText, correlationId, severity: 'error' });
    throw new Error(response.statusText);
  }
};

export default {
  use: () => {
    window.fetch = (originalFetch => (...args: any) => {
      const request: Request = args[1];
      args[1] = requestInterceptor(request);
      const result = originalFetch.apply(this, args);
      return result
        .then((response: Response) => {
          responseInterceptor(request, response);
          return response;
        })
        .catch((e: Error) => {
          if (e.message === noNetworkConnection.status) {
            authentication.logout({ text: noNetworkConnection.message, severity: 'error' });
          }
          throw e;
        });
    })(fetch);
  }
};
